export default __webpack_public_path__ + "img/a8cffde367a964579440aa3cfe73e160.png";